import DashboardHeader from "../../components/common/dashboard/DashboardHeader";
import DashboardHeaderTop from "../../components/common/dashboard/DashboardHeaderTop";
import DashboardSidebarMenu from "../../components/common/dashboard/DashboardSidebarMenu";
import DashboardSidebarMobileMenu from "../../components/common/dashboard/DashboardSidebarMobileMenu";

import HeaderSidebar from "../../components/common/HeaderSidebar";
import MobileMenu from "../../components/common/MobileMenu";
import LoginSignupModal from "../../components/common/login-signup";

import DocumentTable from "../../components/common/dashboard/DocumentListTable";

import React, { useState, useEffect } from 'react'
import { NavLink, useNavigate, useLocation, useParams } from 'react-router-dom';
import CrudService from '../../services/crudService'
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';

export const metadata = {
    title: "Vehicle Documents || Kaga Motors",
};

const ViewDocument = () => {

    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const [orderData, setOrderData] = useState([]);
    const [detailList, setDetailList] = useState([]);
    const [costList, setCostList] = useState([]);
    const [paymentList, setPaymentList] = useState([]);

    const [id, setId] = useState(0);

    const handleViewReport = async (e, docId, fileName) => {
        e.preventDefault();
        alert('Downloading')
		try {
            const response = await CrudService.GetFileData(navigate, location, 'pdf/listing-document', 
            {
                id: docId
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName + '.pdf');
            document.body.appendChild(link);
            link.click();

        } catch (error) {
            console.error('Error downloading the PDF file:', error);
        }
	}

    useEffect(() => {
        if (params.id) {
            console.log('params.id ' + params.id);
            setId(params.id);

            CrudService.GetDataById(navigate, location, 'listing/document', params.id)
            .then((res) => {
                setOrderData(res.data.listing);
                setDetailList(res.data.documents);
            })
        }

    }, [id]);

    if (!params.id)
        navigate(location);


    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });

    return (
        <div className="wrapper">
            <div
                className="offcanvas offcanvas-end"
                tabIndex="-1"
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
            >
                <HeaderSidebar t={t} />
            </div>
            {/* Sidebar Panel End */}

            {/* header top */}
            <DashboardHeaderTop t={t} />
            {/* End header top */}

            {/* Main Header Nav */}
            <DashboardHeader t={t} />
            {/* End Main Header Nav */}

            {/* Main Header Nav For Mobile */}
            <MobileMenu t={t} />
            {/* End Main Header Nav For Mobile */}

            {/* Our Dashbord */}
            <section className="our-dashbord dashbord bgc-f9">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xxl-10 offset-xxl-2 dashboard_grid_space">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="extra-dashboard-menu dn-lg">
                                        <div className="ed_menu_list">
                                            <ul>
                                                <DashboardSidebarMenu t={t} />
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End .row */}

                            <div className="dashboard_navigationbar dn db-lg mt50">
                                <DashboardSidebarMobileMenu t={t} />
                            </div>
                            {/* End mobile navigation */}

                            <div className="row">
                                <div className="col-xl-8">
                                    <div className="breadcrumb_content mb50">
                                        <h2 className="breadcrumb_title">View Documents</h2>
                                        <p>View All Documents on this Vehicle</p>
                                    </div>
                                </div>
                            </div>
                            {/* End .row */}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="new_property_form mb30">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-4 col-md-3">
                                                <p>Ref #: {orderData.ref_no}</p>
                                            </div>
                                            {/* <div class="col-xl-4 col-lg-4 col-md-3">
                                                <p>Description: {(orderData.currency == 1) ? 'JPY' : 'USD'}</p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End .row */}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="new_property_form mb30">
                                        <DocumentTable data={detailList} handleViewReport={handleViewReport}/>
                                    </div>
                                </div>
                            </div>
                            {/* End .row */}
                        </div>
                    </div>
                </div>
            </section>
            {/* End Our Dashbord */}

            {/* Modal */}
            <div
                className="sign_up_modal modal fade"
                id="logInModal"
                data-backdrop="static"
                data-keyboard=""
                tabIndex={-1}
                aria-hidden="true"
            >
                <LoginSignupModal />
            </div>
            {/* End Modal */}
        </div>
        // End wrapper
    );
};

export default ViewDocument;
